let activeChannelsView = null;

export function initChannelsView() {
    const root = document.querySelector('#t-content-wrapper.t-channels');
    if (activeChannelsView?.root === root && root) return;
    activeChannelsView?.destroy();
    activeChannelsView = null;
    if (!root) return;

    const payload = root.querySelector('[data-kh-channels-config]');
    if (!payload) return;
    const config = JSON.parse(payload.textContent);
    const t = (message) => config.messages?.[message] || message;
    const listeners = [];
    let disposed = false;
    const on = (element, type, handler) => {
        element.addEventListener(type, handler);
        listeners.push(() => element.removeEventListener(type, handler));
    };
    const searchControllers = new Set();
    const searchFetch = (url, options) => {
        const controller = typeof AbortController === 'function' ? new AbortController() : null;
        if (controller) searchControllers.add(controller);
        return fetch(url, {...options, ...(controller ? {signal: controller.signal} : {})})
            .finally(() => { if (controller) searchControllers.delete(controller); });
    };
    var searchForm = document.getElementById('t-searchform');
    var searchInput = document.getElementById('teejit-search');
    var searchDropdown = document.getElementById('channels-search-suggestions');
    var filterButtons = document.querySelectorAll('[data-channel-filter]');
    var sections = document.querySelectorAll('[data-channel-section]');
    var activeFilter = config.activeFilter;
    var channelSearchToken = config.accessToken;
    var logoStorageBaseUrl = config.logoStorageBaseUrl;
    var joinByCodeRestUrl = config.joinByCodeRestUrl;
    var joinByCodeFieldsRestUrl = config.joinByCodeFieldsRestUrl;
    var refreshProfileRestUrl = config.refreshProfileRestUrl;
    var teamAdditionalFormRestBaseUrl = config.teamAdditionalFormRestBaseUrl;
    var teamSearchRestUrl = config.teamSearchRestUrl;
    window.khChannelAdditionalFormFieldsByTeam = Object.assign(
        window.khChannelAdditionalFormFieldsByTeam || {},
        config.additionalFieldsByTeam
    );
    window.khChannelPrivacyPolicyUrlsByTeam = Object.assign(
        window.khChannelPrivacyPolicyUrlsByTeam || {},
        config.privacyUrlsByTeam
    );
    var defaultPrivacyPolicyUrl = 'https://teejit.io/datenschutz/';
    var channelSubscribeConsentText = config.consentText;
    var channelPrivacyPolicyLinkLabel = config.privacyLinkLabel;
    var searchDebounceTimer = null;
    var minSearchLength = 3;
    var latestSearchRequestId = 0;

    function escapeHtml(value) {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function normalizePrivacyPolicyUrl(value) {
        var rawUrl = String(value || '').trim();
        if (!rawUrl) {
            return '';
        }

        try {
            var parsedUrl = new URL(rawUrl, window.location.origin);
            if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
                return '';
            }

            return parsedUrl.href;
        } catch (error) {
            return '';
        }
    }

    function getPrivacyPolicyUrlFromPayload(payload) {
        var result = payload && payload.data !== undefined ? payload.data : payload;
        if (!result || typeof result !== 'object') {
            return '';
        }

        var candidates = [
            result.privacy_policy_url,
            result.provider_privacy_policy_url,
            result.provider_privacy_url,
            result.privacy_url,
            result.primary_provider && result.primary_provider.privacy_policy_url,
            result.primary_provider && result.primary_provider.privacy_url,
            result.provider && result.provider.privacy_policy_url,
            result.provider && result.provider.privacy_url,
            result.team && result.team.privacy_policy_url,
            result.team && result.team.privacy_url,
            result.team_data && result.team_data.privacy_policy_url,
            result.team_data && result.team_data.privacy_url,
            result.membership && result.membership.privacy_policy_url,
            result.membership && result.membership.privacy_url
        ];

        for (var i = 0; i < candidates.length; i++) {
            var privacyUrl = normalizePrivacyPolicyUrl(candidates[i]);
            if (privacyUrl) {
                return privacyUrl;
            }
        }

        var providers = Array.isArray(result.providers) ? result.providers : [];
        for (var j = 0; j < providers.length; j++) {
            var provider = providers[j];
            if (!provider || typeof provider !== 'object') {
                continue;
            }

            var providerUrl = normalizePrivacyPolicyUrl(provider.privacy_policy_url || provider.privacy_url);
            if (providerUrl) {
                return providerUrl;
            }
        }

        return '';
    }

    function getChannelPrivacyPolicyUrl(teamId, payload) {
        var payloadPrivacyUrl = getPrivacyPolicyUrlFromPayload(payload);
        if (payloadPrivacyUrl) {
            return payloadPrivacyUrl;
        }

        var normalizedTeamId = teamId ? String(teamId) : '';
        var privacyUrlMap = window.khChannelPrivacyPolicyUrlsByTeam || {};
        if (normalizedTeamId && privacyUrlMap[normalizedTeamId]) {
            return normalizePrivacyPolicyUrl(privacyUrlMap[normalizedTeamId]);
        }

        return normalizePrivacyPolicyUrl(defaultPrivacyPolicyUrl);
    }

    function renderPrivacyPolicyLink(privacyUrl) {
        var normalizedPrivacyUrl = normalizePrivacyPolicyUrl(privacyUrl);
        if (!normalizedPrivacyUrl) {
            return '';
        }

        return '<a class="channel-subscribe-privacy-link" href="' + escapeHtml(normalizedPrivacyUrl) + '" target="_blank" rel="noopener noreferrer">' +
            escapeHtml(channelPrivacyPolicyLinkLabel || 'Privacy Policy') +
            '</a>';
    }

    function updateChannelCodeConsentCopy(privacyUrl) {
        var consentCopy = document.getElementById('channel-code-user-data-consent-copy');
        if (consentCopy) {
            consentCopy.innerHTML = escapeHtml(channelSubscribeConsentText);
        }

        var privacyLinkCopy = document.getElementById('channel-code-user-data-consent-privacy-link');
        var linkHtml = renderPrivacyPolicyLink(privacyUrl);
        if (privacyLinkCopy) {
            privacyLinkCopy.innerHTML = linkHtml;
            privacyLinkCopy.style.display = linkHtml ? '' : 'none';
        }
    }

    function renderLoadingSvg(size) {
        var dimension = parseInt(size || 50, 10);
        if (!Number.isFinite(dimension) || dimension <= 0) {
            dimension = 50;
        }

        return '<svg class="t-loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 436.8 426.76" width="' + dimension + 'px" height="' + dimension + 'px" aria-hidden="true" focusable="false">' +
            '<path class="rotating-group" d="M195.22,393.82c-87.1-11.23-155.38-85-157.53-175.95-1.83-77.32,44.66-144.49,111.76-172.31l24.23-35.63C80.73,30.5,11.16,113.86,11.16,213.59s72.03,186,167.43,204.68l16.63-24.45Z"/>' +
            '<path class="rotating-group" d="M249.79,7.43l-17.01,25.01c91.26,7.23,164.1,82.87,166.33,176.86,1.94,82.07-50.56,152.7-124.36,176.99l-22.47,33.04c98.34-16.27,173.36-102.19,173.36-205.75S349.35,22.65,249.79,7.43Z"/>' +
            '<path class="rotating-group teejit-loading-2" d="M181.85,340.25c-55.23-15.86-95.64-66.74-95.64-127.07s41.57-112.65,98-127.72l23.06-26.17c-80.01,5.71-143.15,72.42-143.15,153.88,0,66.79,42.44,123.66,101.82,145.13l15.92-18.06Z"/>' +
            '<path class="rotating-group teejit-loading-2" d="M263.01,65.46l-16.37,18.57c59.44,12.94,103.95,65.84,103.95,129.16s-47.83,120.07-110.52,130.41l-21.03,23.87c84.92-.34,153.65-69.28,153.65-154.28,0-69.7-46.22-128.59-109.68-147.73Z"/>' +
            '</svg>';
    }

    function normalizeLogoUrl(logo) {
        var value = String(logo || '').trim();
        if (value === '') {
            return '';
        }
        if (/^(https?:)?\/\//i.test(value) || value.indexOf('data:') === 0) {
            return value;
        }
        if (logoStorageBaseUrl) {
            var base = String(logoStorageBaseUrl);
            if (base.slice(-1) !== '/') {
                base += '/';
            }
            value = value.replace(/^\/+/, '');
            return base + value;
        }
        return value;
    }

    function normalizeMaterialIcon(icon) {
        var value = String(icon || '').trim();
        if (value === '') {
            return 'groups';
        }

        value = value.replace(/^material-[ors]-/i, '').replace(/-/g, '_').replace(/[^a-z0-9_]/gi, '');
        return value || 'groups';
    }

    function closeDropdown() {
        if (!searchDropdown) {
            return;
        }
        searchDropdown.style.display = 'none';
    }

    function openDropdown() {
        if (!searchDropdown) {
            return;
        }
        searchDropdown.style.display = 'block';
    }

    function renderDropdownLoading() {
        if (!searchDropdown) {
            return;
        }
        searchDropdown.innerHTML = '' +
            '<div class="t-channel-search-status">' +
                '<div class="lds-dual-ring">' +
                    renderLoadingSvg(36) +
                '</div>' +
                '<span>' + escapeHtml(t("Searching channels, please wait")) + '</span>' +
            '</div>';
        openDropdown();
    }

    function renderDropdownMessage(message) {
        if (!searchDropdown) {
            return;
        }
        searchDropdown.innerHTML = '<div class="t-channel-search-status"><span>' + escapeHtml(message) + '</span></div>';
        openDropdown();
    }

    function renderDropdownResults(teams) {
        if (!searchDropdown) {
            return;
        }
        if (!Array.isArray(teams) || teams.length === 0) {
            renderDropdownMessage(t("No matching channels found."));
            return;
        }

        var html = '<div class="t-channel-search-results">';
        teams.forEach(function(team) {
            var teamId = team && team.team_id !== undefined ? String(team.team_id) : '';
            var teamName = team && team.team_name ? team.team_name : '';
            var logo = normalizeLogoUrl(team && team.logo ? team.logo : '');
            var icon = normalizeMaterialIcon(team && (team.icon || team.team_image_icon) ? (team.icon || team.team_image_icon) : '');
            var href = '/teejit/team/?team-id=' + encodeURIComponent(teamId) + '&from=channels';

            html += '<a class="t-channel-search-item" href="' + href + '">';
            html += '  <div class="t-channel-search-item-left">';
            if (logo) {
                html += '    <img loading="lazy" alt="" src="' + escapeHtml(logo) + '" class="t-channel-search-logo" />';
            } else {
                html += '    <span class="t-channel-search-icon material-symbols-outlined" aria-hidden="true">' + escapeHtml(icon) + '</span>';
            }
            html += '  </div>';
            html += '  <div class="t-channel-search-item-main">';
            html += '    <div class="t-channel-search-title">' + escapeHtml(teamName) + '</div>';
            html += '  </div>';
            html += '  <div class="t-channel-search-item-cta">' + escapeHtml(t("View channel details")) + '</div>';
            html += '</a>';
        });
        html += '</div>';

        searchDropdown.innerHTML = html;
        openDropdown();
    }

    function fetchTeamSearchResults(query) {
        var normalizedQuery = (query || '').trim();
        if (normalizedQuery.length < minSearchLength) {
            closeDropdown();
            return;
        }
        var requestId = ++latestSearchRequestId;
        renderDropdownLoading();

        if (!channelSearchToken) {
            renderDropdownMessage(t("Missing user token for channel search."));
            return;
        }

        var request = function(url) {
            var requestUrl = new URL(url, window.location.origin);
            requestUrl.searchParams.set('q', normalizedQuery);
            var locale = window.khThemeRuntime?.frontendLocale || '';
            if (locale) requestUrl.searchParams.set('frontend_locale', locale);
            return searchFetch(requestUrl.toString(), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + channelSearchToken,
                    ...(locale ? {'X-Frontend-Locale': locale} : {})
                },
                cache: 'no-store'
            }).then(function(response) {
                if (!response.ok) {
                    throw new Error('Request failed');
                }
                return response.json();
            });
        };

        request(teamSearchRestUrl)
            .then(function(payload) {
                if (disposed || requestId !== latestSearchRequestId) {
                    return;
                }
                var teams = payload && Array.isArray(payload.teams) ? payload.teams : [];
                renderDropdownResults(teams);
            })
            .catch(function() {
                if (disposed || requestId !== latestSearchRequestId) {
                    return;
                }
                renderDropdownMessage(t("Channel search failed. Please try again."));
            });
    }

    function applyFilters() {
        filterButtons.forEach(function(button) {
            var isActive = (button.getAttribute('data-channel-filter') || 'all') === activeFilter;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        // Hide/show sections only by selected section filter.
        sections.forEach(function(section) {
            var sectionName = section.getAttribute('data-channel-section');
            if (activeFilter === 'all' || sectionName === activeFilter) {
                section.style.display = '';
            } else {
                section.style.display = 'none';
            }
        });
    }

    if (searchInput) {
        on(searchInput, 'input', function() {
            var value = (searchInput.value || '').trim();
            if (searchDebounceTimer) {
                clearTimeout(searchDebounceTimer);
            }
            searchDebounceTimer = setTimeout(function() {
                if (value === '') {
                    closeDropdown();
                    return;
                }
                if (value.length < minSearchLength) {
                    closeDropdown();
                    return;
                }
                fetchTeamSearchResults(value);
            }, 300);
        });

        on(searchInput, 'focus', function() {
            var value = (searchInput.value || '').trim();
            if (value.length >= minSearchLength && searchDropdown && searchDropdown.innerHTML.trim() !== '') {
                openDropdown();
            }
        });
    }

    if (searchForm && searchInput) {
        on(searchForm, 'submit', function(event) {
            event.preventDefault();
            var value = (searchInput.value || '').trim();
            if (value.length >= minSearchLength) {
                fetchTeamSearchResults(value);
            }
        });
    }

    filterButtons.forEach(function(btn) {
        on(btn, 'click', function() {
            activeFilter = this.getAttribute('data-channel-filter') || 'all';
            applyFilters();
        });
    });

    on(document, 'click', function(event) {
        if (!searchForm) {
            return;
        }
        if (!searchForm.contains(event.target)) {
            closeDropdown();
        }
    });

    applyFilters();

    // Join Team Modal Logic
    var modal = document.getElementById('join-team-modal');
    var joinBtn = document.getElementById('btn-join-team');
    var confirmJoinBtn = document.getElementById('join-team-confirm');
    var codeInput = document.getElementById('team-access-code');
    var consentInput = document.getElementById('channel-code-user-data-consent');
    var joinError = document.getElementById('join-team-error');
    var joinAdditionalForm = document.getElementById('join-team-additional-form');
    var pendingJoinAdditionalFields = [];
    var joinedTeamIdForAdditionalForm = 0;
    var joinedRedirectTeamId = 0;
    var codeAdditionalFieldsLoadedForCode = '';
    var codeAdditionalFieldsReady = false;
    var currentJoinPrivacyPolicyUrl = '';
    var closeButtons = document.querySelectorAll('.channel-code-close');
    window.khChannelJoinByCodeHandledInTemplate = true;

    if (modal && modal.parentNode !== document.body) {
        document.body.appendChild(modal);
    }

    function setJoinError(message) {
        if (!joinError) {
            return;
        }
        joinError.textContent = message || '';
        joinError.style.display = message ? 'block' : 'none';
    }

    function setJoinButtonBusy(message) {
        if (!confirmJoinBtn) {
            return;
        }

        setJoinControlsBusy(true);
        confirmJoinBtn.disabled = true;
        confirmJoinBtn.setAttribute('aria-busy', 'true');
        confirmJoinBtn.classList.add('is-loading');

        var spinner = document.createElement('span');
        spinner.className = 'channel-code-submit-loading';
        spinner.innerHTML = renderLoadingSvg(18);

        var label = document.createElement('span');
        label.textContent = message || '';
        confirmJoinBtn.replaceChildren(spinner, label);
    }

    function setJoinButtonIdle(message) {
        if (!confirmJoinBtn) {
            return;
        }

        setJoinControlsBusy(false);
        confirmJoinBtn.disabled = false;
        confirmJoinBtn.removeAttribute('aria-busy');
        confirmJoinBtn.classList.remove('is-loading');
        confirmJoinBtn.textContent = message || '';
    }

    function setJoinControlsBusy(isBusy) {
        if (codeInput) {
            codeInput.disabled = isBusy;
            codeInput.classList.toggle('is-loading', isBusy);
        }

        if (consentInput) {
            consentInput.disabled = isBusy;
            var consentWrap = consentInput.closest('.channel-user-data-consent-wrap');
            if (consentWrap) {
                consentWrap.classList.toggle('is-loading', isBusy);
                consentWrap.setAttribute('aria-busy', isBusy ? 'true' : 'false');
            }

            var privacyLink = document.querySelector('#channel-code-user-data-consent-privacy-link a');
            if (privacyLink) {
                if (isBusy) {
                    privacyLink.setAttribute('aria-disabled', 'true');
                    privacyLink.setAttribute('tabindex', '-1');
                } else {
                    privacyLink.removeAttribute('aria-disabled');
                    privacyLink.removeAttribute('tabindex');
                }
            }
        }
    }

    function normalizeAdditionalOptions(options) {
        if (typeof options === 'string') {
            var rawOptions = options.trim();
            if (!rawOptions) {
                return [];
            }

            if (/^\s*[\[{]/.test(rawOptions)) {
                try {
                    return normalizeAdditionalOptions(JSON.parse(rawOptions));
                } catch (error) {
                    // Fall through to delimiter splitting.
                }
            }

            options = rawOptions.split(/\r\n|\r|\n|\\r\\n|\\r|\\n|[|;,]+/).map(function(option) {
                return option.trim();
            }).filter(Boolean);
        }

        if (!options || typeof options !== 'object') {
            return [];
        }

        return Object.entries(options).map(function(entry) {
            var optionKey = entry[0];
            var option = entry[1];
            if (option && typeof option === 'object') {
                var value = String(option.value !== undefined ? option.value : optionKey);
                return {
                    value: value,
                    label: String(option.label !== undefined ? option.label : (option.name !== undefined ? option.name : value))
                };
            }

            var scalar = String(option !== undefined ? option : '');
            var scalarValue = /^[0-9]+$/.test(String(optionKey)) ? scalar : String(optionKey);
            return {
                value: scalarValue,
                label: scalar || scalarValue
            };
        }).filter(function(option) {
            return option.value !== '' || option.label !== '';
        });
    }

    function normalizeAdditionalFields(fields) {
        if (!fields || typeof fields !== 'object') {
            return [];
        }

        var seen = {};
        return Object.entries(fields).filter(function(entry) {
            var field = entry[1];
            return field && typeof field === 'object';
        }).map(function(entry) {
            var fallbackKey = entry[0];
            var field = entry[1];
            var fieldKey = String(field.field_key || field.name || field.key || field.id || fallbackKey || '').trim();
            if (!fieldKey || seen[fieldKey]) {
                return null;
            }
            seen[fieldKey] = true;

            var type = String(field.type || field.field_type || field.input_type || 'text').toLowerCase();
            if (type === 'dropdown') {
                type = 'select';
            } else if (type === 'phone') {
                type = 'tel';
            }

            return {
                field_key: fieldKey,
                label: String(field.label || field.title || field.name || fieldKey),
                type: type,
                placeholder: String(field.placeholder || ''),
                help_text: String(field.help_text || field.help || field.description || field.info_text || ''),
                required: field.required === true || field.is_required === true || field.required === 1 || field.is_required === 1 || field.required === '1' || field.is_required === '1' || field.required === 'true' || field.is_required === 'true' || field.required === 'required' || field.registration_mode === 'required' || field.validation_type === 'required',
                options: normalizeAdditionalOptions(field.options || field.values || field.choices || [])
            };
        }).filter(function(field) {
            return field !== null;
        });
    }

    function getAdditionalFieldsFromJoinPayload(payload) {
        var result = payload && payload.data !== undefined ? payload.data : payload;
        if (!result || typeof result !== 'object') {
            return [];
        }

        var fieldSources = [
            result.additional_form_fields,
            result.team && result.team.additional_form_fields,
            result.team_data && result.team_data.additional_form_fields,
            result.membership && result.membership.additional_form_fields
        ];

        for (var i = 0; i < fieldSources.length; i++) {
            var fields = normalizeAdditionalFields(fieldSources[i]);
            if (fields.length > 0) {
                return fields;
            }
        }

        return [];
    }

    function getTeamIdFromJoinPayload(payload) {
        var result = payload && payload.data !== undefined ? payload.data : payload;
        if (!result || typeof result !== 'object') {
            return 0;
        }

        var candidates = [
            result.team_id,
            result.id,
            result.team && (result.team.team_id || result.team.id),
            result.team_data && (result.team_data.team_id || result.team_data.id),
            result.membership && result.membership.team_id
        ];

        for (var i = 0; i < candidates.length; i++) {
            var teamId = parseInt(candidates[i], 10);
            if (Number.isFinite(teamId) && teamId > 0) {
                return teamId;
            }
        }

        return 0;
    }

    function renderAdditionalField(field) {
        var key = escapeHtml(field.field_key);
        var label = escapeHtml(field.label || field.field_key);
        var placeholder = escapeHtml(String(field.placeholder || '').trim());
        var inputPlaceholder = placeholder || label;
        var helpText = escapeHtml(field.help_text || '');
        var required = field.required ? ' required="required"' : '';
        var requiredMark = field.required ? ' <span aria-hidden="true">*</span>' : '';
        var fieldId = 'join-team-additional-' + key.replace(/[^a-z0-9_-]/gi, '-');
        var inputType = ['date', 'email', 'number', 'tel'].indexOf(field.type) !== -1 ? field.type : 'text';
        var control = '';

        if (field.type === 'select') {
            control = '<select id="' + fieldId + '" data-channel-additional-field="' + key + '"' + required + '>';
            control += '<option value="">' + (placeholder || t("Please select")) + '</option>';
            field.options.forEach(function(option) {
                control += '<option value="' + escapeHtml(option.value) + '">' + escapeHtml(option.label || option.value) + '</option>';
            });
            control += '</select>';
        } else if (field.type === 'checkbox') {
            control = '<label class="channel-subscribe-additional-checkbox" for="' + fieldId + '">' +
                '<input type="checkbox" id="' + fieldId + '" value="1" data-channel-additional-field="' + key + '"' + required + '>' +
                '<span>' + (helpText || label) + '</span>' +
                '</label>';
        } else if (field.type === 'textarea') {
            control = '<textarea id="' + fieldId + '" placeholder="' + inputPlaceholder + '" data-channel-additional-field="' + key + '"' + required + '></textarea>';
        } else {
            control = '<input type="' + inputType + '" id="' + fieldId + '" placeholder="' + inputPlaceholder + '" data-channel-additional-field="' + key + '"' + required + '>';
        }

        return '<div class="channel-subscribe-additional-field">' +
            (field.type === 'checkbox' ? '' : '<label for="' + fieldId + '">' + label + requiredMark + '</label>') +
            control +
            (helpText && field.type !== 'checkbox' ? '<small>' + helpText + '</small>' : '') +
            '</div>';
    }

    function renderJoinAdditionalFields(fields) {
        if (!joinAdditionalForm) {
            return;
        }

        pendingJoinAdditionalFields = normalizeAdditionalFields(fields);
        if (pendingJoinAdditionalFields.length === 0) {
            joinAdditionalForm.innerHTML = '';
            joinAdditionalForm.hidden = true;
            return;
        }

        joinAdditionalForm.innerHTML = '<div class="channel-subscribe-additional-title">' +
            escapeHtml(t("Additional channel information")) +
            '</div>' + pendingJoinAdditionalFields.map(renderAdditionalField).join('');
        joinAdditionalForm.hidden = false;
    }

    function resetJoinAdditionalFieldState() {
        joinedTeamIdForAdditionalForm = 0;
        joinedRedirectTeamId = 0;
        codeAdditionalFieldsLoadedForCode = '';
        codeAdditionalFieldsReady = false;
        currentJoinPrivacyPolicyUrl = '';
        renderJoinAdditionalFields([]);
        updateChannelCodeConsentCopy('');
        if (consentInput) {
            consentInput.checked = false;
            consentInput.classList.remove('is-invalid');
        }
        if (confirmJoinBtn) {
            confirmJoinBtn.textContent = t("Verify and subscribe to the channel");
        }
    }

    function collectJoinAdditionalFormData() {
        var data = {};
        var missingLabel = '';

        pendingJoinAdditionalFields.forEach(function(field) {
            var input = null;
            if (joinAdditionalForm) {
                var inputs = joinAdditionalForm.querySelectorAll('[data-channel-additional-field]');
                for (var i = 0; i < inputs.length; i++) {
                    if (inputs[i].getAttribute('data-channel-additional-field') === field.field_key) {
                        input = inputs[i];
                        break;
                    }
                }
            }
            if (!input) {
                return;
            }

            if (field.type === 'checkbox') {
                data[field.field_key] = input.checked ? '1' : '0';
                if (field.required && !input.checked && !missingLabel) {
                    missingLabel = field.label || field.field_key;
                }
                return;
            }

            var value = String(input.value || '').trim();
            data[field.field_key] = value;
            if (field.required && value === '' && !missingLabel) {
                missingLabel = field.label || field.field_key;
            }
        });

        if (missingLabel) {
            return {
                valid: false,
                data: data,
                message: t("Please fill in all required channel information: %s").replace('%s', missingLabel)
            };
        }

        return {
            valid: true,
            data: data,
            message: ''
        };
    }

    var channelWaitlistMessage = t("You are on the waiting list. An admin must approve your request.");

    function isJoinWaitlistPayload(payload) {
        var result = payload && payload.data !== undefined ? payload.data : payload;

        if (!result || typeof result !== 'object') {
            return false;
        }

        var waitlistKeys = [
            'waitlist',
            'waiting_list',
            'on_waiting_list',
            'is_waiting_list',
            'requires_approval',
            'approval_required',
            'admin_approval_required'
        ];

        for (var i = 0; i < waitlistKeys.length; i++) {
            var value = result[waitlistKeys[i]];
            if (value === true || value === 1 || value === '1' || value === 'true') {
                return true;
            }
        }

        var status = String(
            result.status ||
            result.subscription_status ||
            result.membership_status ||
            result.join_status ||
            ''
        ).toLowerCase();

        if (/(waitlist|waiting|pending|approval|request)/.test(status)) {
            return true;
        }

        var message = String(result.message || '').toLowerCase();
        return /(warteliste|waiting list|waitlist|pending|approval|anfrage.*bestät|admin.*bestät)/.test(message);
    }

    function getJoinPayloadStatus(payload) {
        var result = payload && payload.data !== undefined ? payload.data : payload;
        var status = result && result.status !== undefined ? String(result.status).toLowerCase() : '';

        if (status === 'true' || status === 'success') {
            return 'success';
        }
        if (status === 'false' || status === 'error') {
            return 'error';
        }
        if (result && result.success === true) {
            return 'success';
        }
        if (result && result.success === false) {
            return 'error';
        }
        if (payload && payload.success === true && result) {
            return 'success';
        }
        if (isJoinWaitlistPayload(payload)) {
            return 'success';
        }
        return 'error';
    }

    function getJoinPayloadMessage(payload, fallback) {
        var result = payload && payload.data !== undefined ? payload.data : payload;
        return result && result.message ? result.message : fallback;
    }

    function notifyJoin(type, message) {
        if (window.AWN) {
            var notifier = window.KHNotifications && window.KHNotifications.createNotifier ? window.KHNotifications.createNotifier({
                labels: {
                    info: t("Channel"),
                    success: t("Channel"),
                    warning: t("Channel"),
                    alert: t("Channel")
                }
            }) : new window.AWN({labels: {info: t("Channel"), success: t("Channel"), warning: t("Channel"), alert: t("Channel")}});
            if (type === 'success') {
                notifier.success(message, {durations: {global: 5000}});
            } else if (type === 'warning') {
                notifier.warning(message, {durations: {global: 5000}});
            } else {
                notifier.alert(message, {durations: {global: 5000}});
            }
            return;
        }
        setJoinError(message);
    }

    function getGrantedJoinTeamId(payload) {
        if (typeof window.khGetGrantedChannelJoinTeamId === 'function') {
            return window.khGetGrantedChannelJoinTeamId(payload) || 0;
        }

        // The code modal can also run when the main theme bundle is unavailable.
        var result = payload && payload.data !== undefined ? payload.data : payload;
        if (!result || payload.success === false || getJoinPayloadStatus(payload) !== 'success' || isJoinWaitlistPayload(payload)
            || result.access_granted !== true || [1, 3].indexOf(Number(result.approval_status)) !== -1
            || (result.membership_status && result.membership_status !== 'granted')) {
            return 0;
        }
        return getTeamIdFromJoinPayload(payload);
    }

    function refreshChannelsAfterJoin(redirectTeamId) {
        var targetUrl = null;
        if (redirectTeamId > 0) {
            targetUrl = new URL(config.channelProfileUrl);
            targetUrl.searchParams.set('team-id', String(redirectTeamId));
        }
        setTimeout(function() {
            fetch(refreshProfileRestUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Authorization': 'Bearer ' + channelSearchToken
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    user_access_token: channelSearchToken
                })
            }).catch(function() {
                // The join handler has already refreshed the server session.
            }).finally(function() {
                if (targetUrl) {
                    window.location.assign(targetUrl.href);
                } else {
                    window.location.reload();
                }
            });
        }, targetUrl ? 0 : 1500);
    }

    function saveJoinAdditionalFormData(teamId, additionalFormData) {
        if (!teamId) {
            return Promise.reject(new Error(t("Channel data could not be saved.")));
        }

        return fetch(teamAdditionalFormRestBaseUrl + encodeURIComponent(String(teamId)) + '/additional-form-data', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Bearer ' + channelSearchToken
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                user_access_token: channelSearchToken,
                additional_form_data: additionalFormData
            })
        }).then(function(response) {
            return response.json().catch(function() {
                throw new Error(t("Unexpected server response."));
            }).then(function(payload) {
                if (!response.ok || payload.success === false || payload.status === 'error') {
                    throw new Error(payload && payload.message ? payload.message : t("Channel data could not be saved."));
                }

                return payload;
            });
        });
    }

    function fetchJoinAdditionalFieldsByCode(code) {
        return fetch(joinByCodeFieldsRestUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Bearer ' + channelSearchToken
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                code: code,
                user_access_token: channelSearchToken
            })
        }).then(function(response) {
            return response.json().catch(function() {
                throw new Error(t("Unexpected server response."));
            }).then(function(payload) {
                var status = getJoinPayloadStatus(payload);
                if (!response.ok || status !== 'success') {
                    throw new Error(getJoinPayloadMessage(payload, t("Invalid or expired access code.")));
                }

                return payload;
            });
        });
    }

    function submitJoinByCodeRequest(code, additionalFormData) {
        setJoinButtonBusy(t("Subscribing to channel..."));
        notifyJoin('warning', t("Subscribing to channel..."));

        return fetch(joinByCodeRestUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Bearer ' + channelSearchToken
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                code: code,
                user_data_transfer_consent: true,
                additional_form_data: additionalFormData,
                user_access_token: channelSearchToken
            })
        })
            .then(function(response) {
                return response.json().catch(function() {
                    throw new Error(t("Unexpected server response."));
                });
            })
            .then(function(payload) {
                var status = getJoinPayloadStatus(payload);
                var message = isJoinWaitlistPayload(payload)
                    ? channelWaitlistMessage
                    : getJoinPayloadMessage(
                        payload,
                        status === 'success'
                            ? t("Channel successfully joined.")
                            : t("Invalid or expired access code.")
                    );

                if (status === 'success') {
                    var responseFields = getAdditionalFieldsFromJoinPayload(payload);
                    var responseTeamId = getTeamIdFromJoinPayload(payload);
                    var isWaitlist = isJoinWaitlistPayload(payload);
                    var redirectTeamId = getGrantedJoinTeamId(payload);
                    var result = payload && payload.data !== undefined ? payload.data : payload;
                    var additionalDataSaveFailed = result && result.additional_form_data_saved === false;
                    if (!isWaitlist && responseTeamId > 0 && (additionalDataSaveFailed
                        || (responseFields.length > 0 && pendingJoinAdditionalFields.length === 0))) {
                        joinedTeamIdForAdditionalForm = responseTeamId;
                        joinedRedirectTeamId = redirectTeamId;
                        codeAdditionalFieldsReady = true;
                        codeAdditionalFieldsLoadedForCode = code;
                        if (pendingJoinAdditionalFields.length === 0) {
                            renderJoinAdditionalFields(responseFields);
                        }
                        if (confirmJoinBtn) {
                            confirmJoinBtn.textContent = t("Save channel data");
                        }
                        notifyJoin(additionalDataSaveFailed ? 'error' : 'warning', additionalDataSaveFailed
                            ? t("Channel data could not be saved.")
                            : t("Please complete the additional channel information."));
                        return;
                    }

                    if (modal) {
                        modal.style.display = 'none';
                    }
                    notifyJoin(isWaitlist ? 'warning' : 'success', message);
                    refreshChannelsAfterJoin(redirectTeamId);
                    return;
                }

                setJoinError(message);
                notifyJoin('error', message);
            });
    }

    function joinTeamByCode(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }
        }

        var code = codeInput ? codeInput.value.trim() : '';
        setJoinError('');

        if (!code) {
            setJoinError(t("Please enter an access code."));
            return;
        }

        if (codeAdditionalFieldsLoadedForCode && codeAdditionalFieldsLoadedForCode !== code) {
            resetJoinAdditionalFieldState();
        }

        if (!confirmJoinBtn || confirmJoinBtn.disabled) {
            return;
        }

        if (!consentInput || !consentInput.checked) {
            if (consentInput) {
                consentInput.classList.add('is-invalid');
            }
            setJoinError(t("Please confirm that your user information may be transferred to the channel."));
            return;
        }
        consentInput.classList.remove('is-invalid');

        if (!codeAdditionalFieldsReady) {
            var consentWasCheckedBeforeLookup = !!(consentInput && consentInput.checked);
            setJoinButtonBusy(t("Checking code..."));
            fetchJoinAdditionalFieldsByCode(code)
                .then(function(payload) {
                    var responseFields = getAdditionalFieldsFromJoinPayload(payload);
                    var responseTeamId = getTeamIdFromJoinPayload(payload);
                    currentJoinPrivacyPolicyUrl = getChannelPrivacyPolicyUrl(responseTeamId, payload);
                    codeAdditionalFieldsLoadedForCode = code;
                    codeAdditionalFieldsReady = true;
                    joinedTeamIdForAdditionalForm = 0;
                    joinedRedirectTeamId = 0;
                    updateChannelCodeConsentCopy(currentJoinPrivacyPolicyUrl);
                    if (consentInput) {
                        // Keep an already selected consent while the code lookup
                        // populates the provider's privacy policy and any extra fields.
                        consentInput.checked = consentWasCheckedBeforeLookup;
                        consentInput.classList.remove('is-invalid');
                    }
                    if (responseFields.length > 0) {
                        renderJoinAdditionalFields(responseFields);
                        notifyJoin('warning', t("Please complete the additional channel information."));
                        return;
                    }

                    renderJoinAdditionalFields([]);
                    return submitJoinByCodeRequest(code, {});
                })
                .catch(function(error) {
                    var message = error && error.message ? error.message : t("Invalid or expired access code.");
                    setJoinError(message);
                    notifyJoin('error', message);
                })
                .finally(function() {
                    var nextLabel = !codeAdditionalFieldsReady
                        ? t("Verify and subscribe to the channel")
                        : (joinedTeamIdForAdditionalForm > 0
                            ? t("Save channel data")
                            : t("Subscribe to this channel"));
                    setJoinButtonIdle(nextLabel);
                });
            return;
        }

        var additionalFormResult = {
            valid: true,
            data: {},
            message: ''
        };

        if (pendingJoinAdditionalFields.length > 0 || joinedTeamIdForAdditionalForm > 0 || codeAdditionalFieldsReady) {
            additionalFormResult = collectJoinAdditionalFormData();
            if (!additionalFormResult.valid) {
                setJoinError(additionalFormResult.message);
                return;
            }
        }

        if (joinedTeamIdForAdditionalForm > 0) {
            var redirectTeamId = joinedRedirectTeamId;
            setJoinButtonBusy(t("Saving channel data..."));
            notifyJoin('warning', t("Saving channel data..."));
            saveJoinAdditionalFormData(joinedTeamIdForAdditionalForm, additionalFormResult.data)
                .then(function() {
                    if (modal) {
                        modal.style.display = 'none';
                    }
                    notifyJoin('success', t("Channel data saved."));
                    refreshChannelsAfterJoin(redirectTeamId);
                })
                .catch(function(error) {
                    var message = error && error.message ? error.message : t("Channel data could not be saved.");
                    setJoinError(message);
                    notifyJoin('error', message);
                })
                .finally(function() {
                    setJoinButtonIdle(t("Save channel data"));
                });
            return;
        }

        setJoinButtonBusy(t("Subscribing to channel..."));

        submitJoinByCodeRequest(code, additionalFormResult.data)
            .catch(function(error) {
                var message = error && error.message ? error.message : t("Invalid or expired access code.");
                setJoinError(message);
                notifyJoin('error', message);
            })
            .finally(function() {
                setJoinButtonIdle(t("Subscribe to this channel"));
            });
    }

    if (modal) { modal.style.display = 'none'; }

    if (joinBtn) {
        on(joinBtn, 'click', function() {
            modal.style.display = 'flex';
            setJoinError('');
            resetJoinAdditionalFieldState();
            if (codeInput) {
                codeInput.focus();
            }
        });
    }

    closeButtons.forEach(function(btn) {
        on(btn, 'click', function() {
            modal.style.display = 'none';
            resetJoinAdditionalFieldState();
        });
    });

    if (confirmJoinBtn) {
        on(confirmJoinBtn, 'click', joinTeamByCode);
    }

    if (codeInput) {
        on(codeInput, 'input', function() {
            if (codeAdditionalFieldsLoadedForCode && codeInput.value.trim() !== codeAdditionalFieldsLoadedForCode) {
                resetJoinAdditionalFieldState();
            }
        });

        on(codeInput, 'keydown', function(event) {
            if (event.key === 'Enter') {
                joinTeamByCode(event);
            }
        });
    }

    if (modal) {
        on(modal, 'click', function(e) {
            if (e.target === modal) {
                modal.style.display = 'none';
                resetJoinAdditionalFieldState();
            }
        });
    }

    var prefilledChannelCode = config.prefilledChannelCode;
    if (modal && codeInput && prefilledChannelCode) {
        resetJoinAdditionalFieldState();
        modal.style.display = 'flex';
        codeInput.focus();
        codeInput.select();
    }
    activeChannelsView = {
        root,
        destroy() {
            disposed = true;
            clearTimeout(searchDebounceTimer);
            latestSearchRequestId++;
            searchControllers.forEach((controller) => controller.abort());
            listeners.forEach((remove) => remove());
            modal?.remove();
        },
    };
}

document.addEventListener('kh:frontendLocaleChanging', () => {
    activeChannelsView?.destroy();
    activeChannelsView = null;
});
document.addEventListener('kh:frontendLocaleChanged', initChannelsView);
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChannelsView, {once: true});
} else {
    initChannelsView();
}
